import { ControlPanel } from './controls.js';

// Create container for the application
const container = document.createElement('div');
container.style.width = '100vw';
container.style.height = '100vh';
container.style.position = 'relative';
container.style.overflow = 'hidden';
document.body.appendChild(container);

// Initialize control panel
const controlPanel = new ControlPanel(container);

// Export for debugging
window.controlPanel = controlPanel;